import React, { useEffect, useState } from 'react';
import { useParams, Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import { fetchProjects } from '../redux/projectSlice';
import { fetchDictionaties } from '../redux/catalogSlice';

import { addBanner, fetchProjectBanners, deleteBanner, editBanner } from '../redux/bannerSlice';

import PageHeader from '../components/PageHeader';
import {
    BannerListHeader,
    BannerListItem,
    BannerItemModal
} from '../components/banner';
import ConfirmDeleteModal from '../components/ConfirmDeleteModal';

const BannersPage = () => {
    const { projectId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const projects = useSelector(state => state.projects.list);
    const banners = null;
    //const [project, setProject] = useState(projects.find(p => p.id == parseInt(projectId)));
    const project = projects.find(p => p.id == parseInt(projectId));
    const allProjectsNames = projects.map((x, index) => ({ value: x.id, label: x.name }));
    const { list, isLoading, error } = useSelector(state => state.banners);
    const [bannerForEdit, setBannerForEdit] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemForDelete, setItemForDelete] = useState(null); //{entityId: 12}
    //console.log('!!!', useSelector(state => state.catalogs));

    useEffect(() => {
        if (projects.length === 0) {
            dispatch(fetchProjects());
        };
    }, [projects.length, dispatch]);

    useEffect(() => {
        //if (project) {
            const projectId = project?.id
            dispatch(fetchProjectBanners(projectId));
        //};

        const interval = setInterval(() => {
            //if (project) {
                //dispatch(fetchDictionaties());
                //dispatch(fetchProjects());
                const projectId = project?.id
                dispatch(fetchProjectBanners(projectId));
            //};
        }, 10000);
        return () => clearInterval(interval);
    }, [dispatch, project])

    //if (!projectId) {
    //    return (
    //        <Navigate to="/" replace={true} />
    //    )
    //}

    const onSelectProjectHandler = (selected) => {
        //console.log('set project', selected)
        //setProject(projects.find(p => p.id == parseInt(selected.value)));

        navigate(`/banners-page/${selected.value}`); 
    };

    const onAddBannerHandler = () => {
        setBannerForEdit(null);
        setShowModal(true);
    };

    const onEditBannerHandler = (id) => {
        const selectedBanner = list.find(station => station.id === id);
        //console.log(selectedBanner)
        setBannerForEdit({ ...selectedBanner });
        setShowModal(true);
    };


    const onShowDeleteModalHandler = (id) => {
        setItemForDelete({ entityName: list.find(p => p.id === id).name, entityId: id })
        setShowDeleteModal(true);
    }

    const onDeleteHandler = (request) => {
        if (request?.answer === true)
            dispatch(deleteBanner(request?.entityId));
    };

    const onSaveChangesHandler = (bannerItem) => {
        if (bannerItem.id === null) {
            dispatch(addBanner(bannerItem));
        } else {
            dispatch(editBanner(bannerItem));
        };
    };

    return (
        <>
            <PageHeader
                name='Запросы проекта'
                //isLoading={isLoading}
                isVisible={project ? true : false}
                onClickHandler={onAddBannerHandler}
            >
                <Select
                    className="basic-single"
                    classNamePrefix="select"
                    //defaultValue={allProjectsNames.find(p => p.value == parseInt(projectId))}
                    value={projectId ? allProjectsNames.find(p => p.value == parseInt(projectId)) : null}
                    isDisabled={false}
                    isLoading={false}
                    isClearable={true}
                    isRtl={false}
                    isSearchable={true}
                    placeholder={"Выберите проект для добавления запросов."}
                    name="project"
                    options={allProjectsNames}
                    onChange={onSelectProjectHandler}
                />
            </PageHeader>

            {error && <h2>Ошибка: {error}</h2>}

            <div className='banner-list-container'>

                <BannerListHeader />
                {list.length > 0 ?
                    list.map(banner => {
                        const { id } = banner;

                        return (
                            <BannerListItem
                                key={id}
                                banner={banner}
                                projectGuid={projects.find(p => p.id == parseInt(banner?.projectId))?.projectGuid}//{project?.projectGuid}
                                onArchiveBannerHandler={onShowDeleteModalHandler}
                                onEditBannerHandler={onEditBannerHandler}
                            />
                        );
                    })
                    :
                    <div className='no-items'>Список пока пуст.</div>
                }

                <BannerItemModal
                    setShowModal={setShowModal}
                    showModal={showModal}
                    banner={bannerForEdit}
                    onSaveChangesHandler={onSaveChangesHandler}
                    projectId={project ? project.id : bannerForEdit?.projectId}
                    localizationId={project ? project.localizationId : projects.find(p => p.id == parseInt(bannerForEdit?.projectId))?.localizationId}


                    //{projects.find(p => p.id == parseInt(banner.projectId)).}
//                    {project?.id}
//                    {project?.localizationId}

                />
            </div>
            <ConfirmDeleteModal
                entityName={'запрос "' + itemForDelete?.entityName + '"'}
                entityId={itemForDelete?.entityId}
                showModal={showDeleteModal}
                setShowModal={setShowDeleteModal}
                onDeleteHandler={onDeleteHandler}
            />
        </>
    );
};

export default BannersPage;